import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {DeviceOpeService} from "../../../services/ope/deviceOpe.service";
import {GetDevicesCB} from "../../../ope/device/GetDevicesOpe";
import {Device} from "../../../models/device/Device";
import {BaseComponent} from "../../BaseComponent";

@Component({
  selector: 'app-device-selector',
  templateUrl: './device-selector.component.html',
  styleUrls: ['./device-selector.component.css']
})
export class DeviceSelectorComponent extends BaseComponent {

  @Input() inputDisplayMode?: "table" | "dropdown" = "table";
  loadingData: boolean = true;
  /**
   * List containing all the partition devices
   * @protected
   */
  public deviceList: Device[];
  @Input() disabled: boolean = false;
  /**
   * Service used for api calls related to devices
   * @protected
   */
  protected deviceOpeService = inject(DeviceOpeService);
  @Output() private selectedDeviceIdChange = new EventEmitter();

  constructor() {
    super();
    this.deviceList = [];
  }

  private _selectedDeviceId!: number | null;

  get selectedDeviceId(): number | null {
    return this._selectedDeviceId;
  }

  @Input() set selectedDeviceId(value: number | null) {
    if (value !== undefined) {
      this.selectedDeviceIdChange.emit(value);
      this._selectedDeviceId = value;
    }
  }

  private _selectedPartitionId!: number | null;

  get selectedPartitionId(): number | null {
    return this._selectedPartitionId;
  }

  @Input() set selectedPartitionId(value: number | null) {
    this._selectedPartitionId = value;
    if (!this.disabled) {
      this.selectedDeviceId = null;
    }
    this.loadPartitionDevices(value)
  }

  /**
   * Calls the getDevices api in order to retrieve and show all the selected partition's devices.
   * Also put the Calculated Fields item in the array to let the user select Calculated Fields
   * @param partitionId
   */
  async loadPartitionDevices(partitionId: number | null) {
    if (!!partitionId || partitionId === 0) {
      this.deviceList = [];
      let cb = new GetDevicesCB();
      cb.i.partitionId = partitionId;
      this.loadingData = true;
      this.deviceOpeService.getDevices(cb).then(
        () => {
          cb.o.devices.forEach((deviceDto: any) => {
            let device = new Device();
            device.id = deviceDto.id;
            device.online = deviceDto.online;
            device.name = deviceDto.name;
            device.partitionId = deviceDto.partitionId;
            this.deviceList.push(device);
          });
          this.deviceList.sort((a, b) => a.name.localeCompare(b.name));
          let calculatedFields = new Device();
          calculatedFields.name = this.translate.instant("REGISTRY.DEVICE.VIRTUAL_METRICS");
          calculatedFields.isVirtualMeasure = true;
          calculatedFields.id = -2;
          this.deviceList.push(calculatedFields);
          this.loadingData = false;
        }).catch(
        (err: any) => {
          this.loadingData = false;
        });

    }
  }

}
